/* Prime Raw — image hotspots: one open at a time, closes on outside click / Escape. */
if (!customElements.get('pr-hotspots')) {
  customElements.define(
    'pr-hotspots',
    class PrHotspots extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.spots = Array.prototype.slice.call(this.querySelectorAll('.pr-hotspot'));

        this.spots.forEach(function (spot) {
          var dot = spot.querySelector('.pr-hotspot__dot');
          dot.addEventListener('click', function (event) {
            event.stopPropagation();
            var open = spot.classList.contains('is-open');
            self.closeAll();
            if (!open) {
              spot.classList.add('is-open');
              dot.setAttribute('aria-expanded', 'true');
            }
          });
        });

        this.onDocClick = function (event) {
          if (!self.contains(event.target) || !event.target.closest('.pr-hotspot__card')) self.closeAll();
        };
        this.onKey = function (event) {
          if (event.key === 'Escape') self.closeAll();
        };
        document.addEventListener('click', this.onDocClick);
        document.addEventListener('keydown', this.onKey);

        // Open the first spot once the image scrolls into view (larger screens), so visitors see the interaction.
        if (window.matchMedia('(min-width: 750px)').matches && this.spots[0] && 'IntersectionObserver' in window) {
          this.io = new IntersectionObserver(function (entries) {
            if (!entries[0].isIntersecting) return;
            self.io.disconnect();
            if (!self.querySelector('.pr-hotspot.is-open')) self.spots[0].querySelector('.pr-hotspot__dot').click();
          }, { threshold: 0.5 });
          this.io.observe(this);
        }
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onKey);
      }

      closeAll() {
        this.spots.forEach(function (spot) {
          spot.classList.remove('is-open');
          spot.querySelector('.pr-hotspot__dot').setAttribute('aria-expanded', 'false');
        });
      }
    }
  );
}
